import { RefreshAcademicRegistrationMessageParams } from './checkout-sanitized-start-params';

export interface AcademicRegistration {
  type: 'ACADEMIC_REGISTRATION';
  startParams: RefreshAcademicRegistrationMessageParams;
}
